/**
 *  OCS Highchart tooltip override
 *  This module overrides the refresh method in highcharts for the tooltip. Uses closest point for tooltip display. Does not have to be exact point.
 *  Made to show wind direction in the tooltip for the barbs on the charts.
 *
 *	Requires Moolite 1.3
 *	Requires Highcharts
 *	Requires OCS Utilities 1.0.1
 *	Requires OCSJsManagers 1.3.3
 *	Requires Jquery
 */

Highcharts.wrap(Highcharts.Tooltip.prototype, 'refresh', function(proceed) {
    var compare = function (a, b) {
        if (a.series._i < b.series._i) {
            return -1
        } else if (a.series._i > b.series._i) {
            return 1
        }
        return 0
    }
    var args = arguments,
        points = args[1],
        point = points[0];


    if (typeof points[0] !== "undefined") {
        chart = point.series.chart;
    } else {
        chart = points;
    }

    // Loop over all the series of the chart
    Highcharts.each(chart.series, function(series) {
        // This one already exist
        if (series == point.series || series.visible == false) return;

        var current,
            dist,
            distance = Number.MAX_VALUE;
        // Loop over all the points
        Highcharts.each(series.points, function(p) {
            // use the distance in X to determine the closest point
            dist = Math.abs(p.x - point.x);
            if (dist < distance) {
                distance = dist;
                current = p;
            }
        });

        // Add the closest point to the array
        if (points.indexOf(current) == -1)
            points.push(current);
    });
    points = points.sort(compare);
    proceed.apply(this, [].slice.call(args, 1));
});